// extracted by mini-css-extract-plugin
export default {"link":"task_link__sf7iM"};